import typeCheck from 'common/util/typeCheck';
import { APPLICATION_FORM_TYPE_RENTER_PREQUAL } from 'common/householdApplication/applicationFormFields';
import updateRenterProfileAction from 'client/actions/Household/updateRenterProfile';
import redirectToApplicationFormAction from 'client/actions/Household/redirectToApplicationForm';

export default async function startPrequal(inject, { userId, listingId }) {
  typeCheck('userId::PositiveNumber', userId);
  typeCheck('listingId::PositiveNumber', listingId);

  await updateRenterProfileAction(inject, {
    userId,
    updates: {
      hasStartedPrequal: true,
    },
  });
  return redirectToApplicationFormAction(inject, {
    formType: APPLICATION_FORM_TYPE_RENTER_PREQUAL,
    prequalListingId: listingId,
    shouldRestart: true,
  });
}
